<script setup lang="ts">
  import { useTitle } from '@vueuse/core';
  import { watchEffect, computed, provide, onErrorCaptured, type ComputedRef } from 'vue';
  import { useRoute } from 'vue-router';
  import { useWindowSize } from '@vueuse/core';

  const route = useRoute();
  const title = useTitle();
  const { width } = useWindowSize();
  const isMobile = computed(() => width.value < 768);
  const isTablet = computed(() => width.value <= 1024 && width.value >= 768);
  const isDesktop = computed(() => width.value > 1024);

  watchEffect(() => {
    title.value = route.meta.title
      ? `MyScanSource - ${route.meta.title}`
      : 'MyScanSource';
  });

  onErrorCaptured((error) => {
    console.error('Error captured in App.vue', error);
    return false;
  });

  provide<ComputedRef<boolean>>('$isMobile', isMobile);
  provide<ComputedRef<boolean>>('$isTablet', isTablet);
  provide<ComputedRef<boolean>>('$isDesktop', isDesktop);
</script>

<template>
  <RouterView />
</template>
